import { SectionLabel, Headline } from "@/components/Doc";
import { FolderCard } from "@/components/FolderCard";
import { MODULES } from "@/data/modules";

export default function Modules() {
  return (
    <main className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28" data-testid="modules-page">
      <SectionLabel right="Form LH-03">Doc. 03 — The Curriculum</SectionLabel>
      <Headline as="h1" className="mt-10 text-4xl sm:text-5xl lg:text-6xl">The four modules.</Headline>
      <p className="t-body text-lg sm:text-xl mt-6 max-w-[60ch] leading-[1.65]">
        Each module is two days, in person, for a cohort of your own people. Each ends with a physical artifact and a written change to how the work is done. Take one as an entry point, or all four across a quarter.
      </p>
      <div className="grid md:grid-cols-2 gap-10 mt-16">
        {MODULES.map((m) => <FolderCard key={m.slug} m={m} />)}
      </div>
    </main>
  );
}
